/* ═══════════════════════════════════════════
   perfekt unperfekt – Shopify Theme JS
   ═══════════════════════════════════════════ */

'use strict';

/* ── CONSTANTS ── */
const SHIPPING_FREE_AT = 6000; // in Cent
const COUPON_CODE      = 'WILLKOMMEN10';
const COUPON_DISCOUNT  = 0.10;

/* ── STATE ── */
let couponApplied  = false;
let giftMessage    = '';

/* ─────────────────────────────────────────────
   CART DRAWER OPEN / CLOSE
───────────────────────────────────────────── */
function openCartDrawer() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.body.style.overflow = 'hidden';
  document.getElementById('cart-drawer').focus();
}

function closeCartDrawer() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.body.style.overflow = '';
}

/* ─────────────────────────────────────────────
   FETCH CART & RENDER
───────────────────────────────────────────── */
async function fetchAndRenderCart() {
  try {
    const res  = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    const cart = await res.json();
    renderCartDrawer(cart);
    updateCartBadge(cart.item_count);
  } catch (e) {
    console.error('Cart fetch error:', e);
  }
}

function renderCartDrawer(cart) {
  const body    = document.getElementById('cart-items-container');
  const empty   = document.getElementById('cart-drawer-empty');
  const footer  = document.getElementById('cart-drawer-footer');
  const countLbl = document.getElementById('cart-drawer-count');

  if (!cart.item_count) {
    body.style.display   = 'none';
    empty.style.display  = 'block';
    footer.style.display = 'none';
    countLbl.textContent = '';
    updateShippingBar(0);
    return;
  }

  empty.style.display  = 'none';
  body.style.display   = 'block';
  footer.style.display = 'block';
  countLbl.textContent = cart.item_count + (cart.item_count === 1 ? ' Artikel' : ' Artikel');

  /* Render items */
  body.innerHTML = cart.items.map(item => `
    <div class="cart-item" id="cart-item-${item.key}">
      <div class="cart-item__image">
        ${item.image
          ? `<img src="${item.image}" alt="${escapeHtml(item.product_title)}" width="56" height="56" loading="lazy">`
          : `<span style="font-size:1.4rem;">${item.product_title.includes('Groß') ? '🕯️' : item.product_title.includes('Mittel') ? '🕯️' : '🕯️'}</span>`
        }
      </div>
      <div class="cart-item__info">
        <p class="cart-item__title">${escapeHtml(item.product_title)}</p>
        ${item.variant_title && item.variant_title !== 'Default Title'
          ? `<p class="cart-item__variant">${escapeHtml(item.variant_title)}</p>` : ''}
        <div class="cart-item__bottom">
          <div class="cart-item__qty">
            <button onclick="updateLineItemQty('${item.key}', ${item.quantity - 1})" aria-label="Menge verringern">−</button>
            <span>${item.quantity}</span>
            <button onclick="updateLineItemQty('${item.key}', ${item.quantity + 1})" aria-label="Menge erhöhen">+</button>
          </div>
          <span class="cart-item__price">${formatMoney(item.line_price)}</span>
        </div>
      </div>
      <button class="cart-item__remove" onclick="removeLineItem('${item.key}')" aria-label="${escapeHtml(item.product_title)} entfernen">✕</button>
    </div>
  `).join('');

  /* Totals */
  const subtotal = cart.original_total_price;
  const discount = couponApplied ? Math.round(subtotal * COUPON_DISCOUNT) : 0;
  const afterDisc = subtotal - discount;
  const shipping  = afterDisc >= SHIPPING_FREE_AT ? 0 : 490;
  const total     = afterDisc + shipping;

  document.getElementById('cart-subtotal').textContent      = formatMoney(subtotal);
  document.getElementById('cart-shipping-cost').textContent = shipping === 0 ? 'Kostenlos' : formatMoney(shipping);
  document.getElementById('cart-total-price').textContent   = formatMoney(total);

  const discRow = document.getElementById('discount-row');
  if (couponApplied && discount > 0) {
    discRow.style.display = 'flex';
    document.getElementById('discount-amount').textContent = '– ' + formatMoney(discount);
  } else {
    discRow.style.display = 'none';
  }

  updateShippingBar(afterDisc);
}

function updateShippingBar(amount) {
  const fill = document.getElementById('cart-progress-fill');
  const text = document.getElementById('cart-progress-text');
  if (!fill || !text) return;

  const pct       = Math.min(100, (amount / SHIPPING_FREE_AT) * 100);
  const remaining = Math.max(0, SHIPPING_FREE_AT - amount);

  fill.style.width = pct + '%';
  text.innerHTML   = remaining > 0
    ? `Noch <strong>${formatMoney(remaining)}</strong> bis zum <strong>kostenlosen Versand</strong>`
    : `<strong style="color:var(--color-teal)">✓ Du erhältst kostenlosen Versand!</strong>`;
}

function updateCartBadge(count) {
  document.querySelectorAll('[id="cart-count"], .cart-count').forEach(el => {
    el.textContent = count;
  });
  document.getElementById('cart-count') && (document.getElementById('cart-count').textContent = count);
}

/* ─────────────────────────────────────────────
   CART MUTATIONS (Shopify AJAX API)
───────────────────────────────────────────── */
async function addToCartAjax(variantId, quantity = 1, properties = {}) {
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity, properties })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    const item = await res.json();
    await fetchAndRenderCart();
    showToast(item.product_title + ' wurde hinzugefügt ✓');
    setTimeout(openCartDrawer, 600);
  } catch (e) {
    console.error(e);
    showToast('Fehler beim Hinzufügen. Bitte erneut versuchen.');
  }
}

async function updateLineItemQty(key, qty) {
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty) })
    });
    await res.json();
    await fetchAndRenderCart();
  } catch (e) {
    console.error(e);
  }
}

async function removeLineItem(key) {
  await updateLineItemQty(key, 0);
}

/* ─────────────────────────────────────────────
   QUICK ADD (product cards & pages)
───────────────────────────────────────────── */
window.addToCartQuick = function(variantId) {
  if (!variantId) return;
  const props = {};
  const giftMsg = document.getElementById('gift-text');
  if (giftMsg && giftMsg.value.trim()) {
    props['Grußkarte'] = giftMsg.value.trim();
  }
  addToCartAjax(variantId, 1, props);
};

/* ─────────────────────────────────────────────
   COUPON
───────────────────────────────────────────── */
window.applyCoupon = function() {
  const input = document.getElementById('coupon-input');
  if (!input) return;
  const val = input.value.trim().toUpperCase();
  if (val === COUPON_CODE) {
    couponApplied = true;
    const ok = document.getElementById('coupon-success');
    if (ok) ok.style.display = 'block';
    fetchAndRenderCart();
    showToast('Gutschein WILLKOMMEN10 angewendet ✓');
  } else {
    showToast('Ungültiger Gutscheincode');
  }
};

/* ─────────────────────────────────────────────
   GIFT MESSAGE
───────────────────────────────────────────── */
window.toggleGiftMsg = function() {
  const check = document.getElementById('gift-check');
  const wrap  = document.getElementById('gift-message');
  if (!wrap) return;
  wrap.style.display = check.checked ? 'block' : 'none';
};

/* ─────────────────────────────────────────────
   MOBILE NAV
───────────────────────────────────────────── */
function initMobileNav() {
  const toggle = document.querySelector('[data-mobile-menu-toggle]');
  const nav    = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;
  nav.hidden = true;
  toggle.addEventListener('click', () => {
    const isHidden = nav.hidden;
    nav.hidden = !isHidden;
    toggle.setAttribute('aria-expanded', String(isHidden));
  });
}

/* ─────────────────────────────────────────────
   VARIANT SELECTOR (product page)
───────────────────────────────────────────── */
function initVariantSelector() {
  const productData = document.querySelector('[data-product-json]');
  if (!productData) return;

  const product = JSON.parse(productData.textContent);

  document.querySelectorAll('.product-page__option-value input').forEach(radio => {
    radio.addEventListener('change', () => {
      // Style selected
      const fieldset = radio.closest('fieldset');
      fieldset.querySelectorAll('.product-page__option-value').forEach(l => l.classList.remove('selected'));
      radio.closest('.product-page__option-value').classList.add('selected');

      // Find matching variant
      const selectedOpts = [...document.querySelectorAll('.product-page__option-value input:checked')]
        .map(r => r.value);

      const variant = product.variants.find(v =>
        v.options.every((opt, i) => opt === selectedOpts[i])
      );

      if (variant) {
        document.getElementById('variant-id').value = variant.id;
        const priceEl = document.getElementById('product-price');
        if (priceEl) {
          priceEl.querySelector('.product-page__price-current').textContent = formatMoney(variant.price);
        }
        const btn = document.getElementById('add-to-cart-btn');
        if (btn) {
          btn.dataset.variantId = variant.id;
          btn.disabled = !variant.available;
          btn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        }
      }
    });
  });
}

/* ─────────────────────────────────────────────
   TOAST
───────────────────────────────────────────── */
let toastTimer;
window.showToast = function(msg) {
  const toast = document.getElementById('toast');
  const msgEl = document.getElementById('toast-msg');
  if (!toast || !msgEl) return;
  msgEl.textContent = msg;
  toast.classList.add('show');
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => toast.classList.remove('show'), 3200);
};

/* ─────────────────────────────────────────────
   UTILITIES
───────────────────────────────────────────── */
function formatMoney(cents) {
  return (cents / 100).toFixed(2).replace('.', ',') + ' €';
}

function escapeHtml(str) {
  const d = document.createElement('div');
  d.textContent = str;
  return d.innerHTML;
}

/* ─────────────────────────────────────────────
   INIT
───────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', () => {

  /* Cart triggers */
  document.querySelectorAll('[data-cart-trigger]').forEach(btn => {
    btn.addEventListener('click', openCartDrawer);
  });

  document.querySelectorAll('[data-cart-close]').forEach(el => {
    el.addEventListener('click', closeCartDrawer);
  });

  /* ESC key closes drawer */
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* Coupon input: enter key */
  const couponInput = document.getElementById('coupon-input');
  if (couponInput) {
    couponInput.addEventListener('keydown', e => {
      if (e.key === 'Enter') applyCoupon();
    });
  }

  /* Initial cart render */
  fetchAndRenderCart();

  /* Mobile nav */
  initMobileNav();

  /* Variant selector */
  initVariantSelector();
});
